import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import ROUTES from "../../AppRouter/routes";
import TrayViewer from "./TrayViewer";
import { viewTray, fetchTray, finishCapture } from "../../../actions";
import { useWebServer } from "../../../providers";

const ViewTray = ({ viewTray, fetchTray, finishCapture, tray, trayId }) => {
  const history = useHistory();
  const { sendRequest } = useWebServer();
  const [hasViewed, setHasViewed] = useState(false);
  const [previousTray, setPreviousTray] = useState();

  useEffect(() => {
    const loadTray = async () => {
      if (hasViewed && previousTray === trayId) return;
      if (trayId) {
        if (tray?.id && tray?.specimens) {
          await viewTray(tray);
          setHasViewed(true);
          setPreviousTray(trayId);
        } else {
          await fetchTray(trayId, {}, sendRequest);
        }
      } else {
        history.push(ROUTES.traysTab);
      }
    };
    loadTray();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tray]);

  useEffect(() => {
    if (hasViewed) {
      return () => {
        finishCapture();
      };
    }
  }, [hasViewed, finishCapture]);

  return (
    <TrayViewer />
  );
};

export const mapStateToProps = (state, ownProps) => {
  const trayId = ownProps.match.params.id;
  const { selectedDevice } = state.devices;
  if (!selectedDevice) return {};
  const {
    [selectedDevice]: {
      trays: { [trayId]: tray },
    },
  } = state.devices;

  return {
    tray,
    trayId,
  };
};

export default connect(mapStateToProps, { viewTray, fetchTray, finishCapture })(
  ViewTray
);
